import { render, staticRenderFns } from "./TemplateDesignerHeader.vue?vue&type=template&id=6c735038"
import script from "./TemplateDesignerHeader.vue?vue&type=script&lang=js"
export * from "./TemplateDesignerHeader.vue?vue&type=script&lang=js"
import style0 from "./TemplateDesignerHeader.vue?vue&type=style&index=0&id=6c735038&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c735038')) {
      api.createRecord('6c735038', component.options)
    } else {
      api.reload('6c735038', component.options)
    }
    module.hot.accept("./TemplateDesignerHeader.vue?vue&type=template&id=6c735038", function () {
      api.rerender('6c735038', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/TemplateDesignerHeader.vue"
export default component.exports